import { EntityConfig } from "@components-fabric";

/**
 * Configuration Object: buildingParametersPresetsEntity
 * 
 * This configuration object defines the entity for building parameters presets. It includes settings for
 * the entity's ID, columns, endpoints, name, schema, and empty state.
 * 
 * Properties:
 * @property {string} id - The unique identifier for the entity.
 * @property {Array<string>} columns - The columns to be used in the entity, typically for display or data management purposes.
 * @property {string} endpoints - The API endpoint for interacting with the entity's data.
 * @property {string} name - The name of the entity, used for identification and display purposes.
 * @property {object} schema - The schema definition for the entity, specifying the structure and validation rules.
 * @property {object} empty - An empty state object representing the default state of the entity.
 * 
 * Example Usage:
 * import { buildingParametersPresetsEntity } from 'path-to-this-file';
 * 
 * // Use buildingParametersPresetsEntity in a component or service
 * 
 * @type {EntityConfig<any>}
 */
export const buildingParametersPresetsEntity: EntityConfig<any> = {
    id: 'building_parameters',
    columns: ['name', { id: 'sourceType' }, 'description'],
    endpoints: '/buildingms/presets',
    name: 'BuildingParametersPresets',
    schema: {},
    empty: {},
  };
